import { getMarkupExcerpt } from "shared/schema";
import { useItem } from "../util/db.js";
import { CommentHeader } from "./Comment.js";

export function CommentCard({ id }: { id: string }): React.ReactElement {
	const data = useItem("comment", id).data;
	const { content } = data;
	return (
		<article className="card targeted">
			<CommentHeader {...data} />
			<p>{getMarkupExcerpt(content)}</p>
		</article>
	);
}
